<template>
  <div class="apply_box">
    <div class="notice">请保持银行卡号、身份证、预留手机号一致</div>
    <!-- <div class="bg"></div> -->
    <div class="pro_detail">
      <!-- <div class="pro_item">
        <h1 class="h1"><span class="line"></span> 绑定银行卡 </h1>
      </div> -->
      <div class="pro_item1" v-for="(item, index) in bankList" :key="index">
        <span class="label">{{ item.title }}</span>
        <input
          type="text"
          :placeholder="item.placeholder"
          class="inputStyle1"
          :class="{ inputStyle: item.type == 3 }"
          v-model="item.value"
          :readOnly="item.readOnly"
        />
        <span
          v-if="!cutStart && item.type == 3"
          class="replace_btn right"
          @click="getMsgCode"
          >获取验证码</span
        >
        <span v-if="cutStart && item.type == 3" class="replace_btn right cc"
          >剩余{{ second }}s</span
        >
      </div>
    </div>
    <div class="info_box" v-if="loanPlatformJson">
      <div class="xy_box">
        <span
          class="icon_circle"
          :class="{ icon_circleAct: isActive }"
          @click="checkStatus()"
        ></span>
        {{ loanPlatformJson.title1 }}
        <span class="agree" @click="toSuportBank(loanPlatformJson.pageUrl)">{{
          loanPlatformJson.title2
        }}</span>
      </div>
    </div>
    <div class="loan_btn" @click="bindBank">确认</div>
    <div class="info">
      <!-- <p><img class="bank_icon"
             src="../../assets/img/afterLoan/bank_icon.png"
             alt="">
        请保证银行卡号、身份证号、预留手机号一致</p> -->
      <p class="bank_list" @click="toSuportBank(supportCardList.pageUrl)">
        {{ supportCardList.title }}
      </p>
    </div>
    <!-- <div class="help">
      <a href="javascript.void(0)">绑卡失败，咨询客服</a>
    </div> -->

    <Loading :isShow="isShowLoading"></Loading>
  </div>
</template>

<script>
import Loading from "@/components/loading";
export default {
  components: { Loading },
  data() {
    return {
      isShowLoading: false,
      second: 59,
      cutStart: false,
      productId: "",
      name: "",
      bankCardId: "",
      phone: "",
      veifyCode: "",
      bankList: [],
      bankInfo: [],
      realName: "",
      isActive: true,
      supportCardList: {},
      loanPlatformJson: {},
      authId: ""
    };
  },
  mounted() {
    this.authId = this.$route.query.authId;
    this.util.title("绑定银行卡");
    this.getBankList();
  },
  methods: {
    checkStatus() {
      this.isActive = !this.isActive;
    },
    toSuportBank(pageUrl) {
      // this.$router.push({
      //   path: '/afterLoan/suportBank',
      //   query: {
      //   }
      // });
      window.location.href = pageUrl;
    },
    getBankList() {
      let _this = this;
      this.$get("/app/api/v1/binding/bankcard", {
        authId: this.authId
      })
        .then(res => {
          var e = res;
          if (e.code == 200) {
            let data = e.data.content;
            _this.supportCardList = e.data.supportCardList;
            _this.realName = e.data.realName;
            let arr = [];
            _this.loanPlatformJson = e.data.loanPlatform;
            e.data.content.map(function(item) {
              return arr.concat(item.sub);
            });
            data.map(function(item) {
              item.sub.map(function(itm) {
                if (itm.type != 4) {
                  if (itm.type == 1) {
                    // itm.value = e.data.realName;
                    itm.readOnly = "readOnly";
                  }
                  return _this.bankList.push(itm);
                }
              });
            });
            let arr1 = [];
            _this.bankList.map(function(item) {
              return _this.bankInfo.push(item.key);
            });
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => {});
    },
    getMsgCode() {
      //获取验证码
      let _this = this;
      _this.isShowLoading = true;
      let param = {};
      let yzmList = [];
      this.bankList.map(function(item, index) {
        if (item.type == 2 || item.type == 1) {
          yzmList.push(item);
        }
      });
      let len = yzmList.length;
      yzmList.map(function(item, index) {
        if (item.value == "" || item.value == undefined || item.value == null) {
          _this.util.toast({ msg: item.placeholder });
          return false;
        } else {
          --len;
          return (param[item.key] = item.value);
        }
      });
      if (len > 0) {
        return false;
      }
      let json = JSON.stringify(param);
      this.$post("/app/api/v1/baseinfo", {
        authId: _this.authId,
        baseInfo: json
      }).then(res => {
        if (res.code == 200) {
          this.cutdown();
        } else {
          this.util.toast({ msg: res.message, type: "fail" });
        }
        _this.isShowLoading = false;
      });
    },
    cutdown() {
      //倒计时
      this.cutStart = true;
      if (this.second == 0) {
        this.cutStart = false;
        this.second = 59;
        return;
      } else {
        this.second = this.second - 1;
        setTimeout(() => {
          this.cutdown();
        }, 1000);
      }
    },
    //调用android和ios的方法
    authSuccess() {
      try {
        window.webkit.messageHandlers.authSuccess.postMessage(""); //ios
      } catch (err) {
        window.AppJs.authSuccess(); //android
      }
    },
    bindBank() {
      //绑定银行卡
      let _this = this;
      let param = {};
      let len = this.bankList.length;
      param = {
        authId: this.authId
      };
      this.bankList.map(function(item, index) {
        if (item.value == "" || item.value == undefined || item.value == null) {
          _this.util.toast({ msg: item.placeholder });
          return false;
        } else {
          --len;
          return (param[item.key] = item.value);
        }
      });
      if (len > 0) {
        return false;
      }
      if (_this.loanPlatformJson && !_this.isActive) {
        _this.util.toast({ msg: "请先勾选协议" });
        return false;
      }
      _this.isShowLoading = true;
      this.$post("/app/api/v1/bank/sureBindBank", param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.util.toast({ msg: "绑卡成功" });
            _this.authSuccess();
          } else {
            _this.util.toast({ msg: e.message });
          }
          _this.isShowLoading = false;
        })
        .catch(error => {});
    }
  }
};
</script>
<style scoped>
html {
  font-size: 62.5%;
}
.notice {
  padding: 0.12rem 0 0.1rem 0;
  font-size: 0.14rem;
  color: #5983fc;
  background: #e6ebff;
  text-align: center;
}
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
  font-size: 0.24rem;
}
.pro_detail {
  background: #ffffff;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
  padding: 0.15rem;
  padding: 0.15rem 0;
}

.pro_item1 {
  clear: both;
  overflow: hidden;
  border-bottom: 1px solid #eee;
  padding: 0 0.15rem;
}
.label {
  font-size: 0.14rem;
  color: #666;
  display: inline-block;
  width: 0.75rem;
}
.inputStyle,
.inputStyle1 {
  padding: 0.15rem;
  color: #ccc;
  font-size: 0.14rem;
  width: 74%;
}
.inputStyle {
  width: 50%;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.4rem;
}
.info {
  padding: 0 0.15rem;
  color: #333;
  font-size: 0.11rem;
  text-align: center;
  width: 100%;
  padding-top: 0.08rem;
}
.info p {
  font-size: 0.12rem;
  color: #999;
  text-align: center;
}
.bank_list {
  color: #486cff;
  margin-top: 0.2rem;
  display: inline-block;
  /* padding-left: 0.25rem; */
}
.bank_icon {
  display: inline-block;
  width: 0.16rem;
  height: 0.1rem;
  margin-right: 0.05rem;
}
.help {
  width: 100%;
  position: fixed;
  bottom: 0.2rem;
  left: 0;
  color: #999;
  font-size: 0.11rem;
  text-align: center;
}
.cc {
  color: #ccc;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.024rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/choice_unCheck.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url("../../assets/img/afterLoan/checked.png") no-repeat top center;
  background-size: 100% 100%;
}
</style>
